const __vite__mapDeps = (
  i,
  m = __vite__mapDeps,
  d = m.f ||
    (m.f = [
      "./dialog-Ct72qeOD.js",
      "./component-CAYPdBLR.js",
      "./events-CnaEWcY_.js",
      "./dialog-Dc8vT9Bk.css",
      "./predictive-search-Dq3dzU3G.js",
      "./section-renderer-O9dH0e4S.js",
      "./morph-BgZiyH00.js",
    ])
) => i.map((i) => d[i]);
import "./carousel-embla-DBPoCNBa.js";
import "./instant-router-C8DHeCu7.js";
import { C as De, b as nt, c as rt } from "./events-CnaEWcY_.js";
import "./component-CAYPdBLR.js";
import "./cache-B3iI9tCV.js";
import "./section-renderer-O9dH0e4S.js";
import "./morph-BgZiyH00.js";
const it = "modulepreload",
  ot = function (t, e) {
    return new URL(t, e).href;
  },
  ke = {},
  X = function (e, n, r) {
    let a = Promise.resolve();
    if (n && n.length > 0) {
      let l = function (u) {
        return Promise.all(
          u.map((h) =>
            Promise.resolve(h).then(
              (y) => ({ status: "fulfilled", value: y }),
              (y) => ({ status: "rejected", reason: y })
            )
          )
        );
      };
      const o = document.getElementsByTagName("link"),
        s = document.querySelector("meta[property=csp-nonce]"),
        d = s?.nonce || s?.getAttribute("nonce");
      a = l(
        n.map((u) => {
          if (((u = ot(u, r)), u in ke)) return;
          ke[u] = !0;
          const h = u.endsWith(".css"),
            y = h ? '[rel="stylesheet"]' : "";
          if (r)
            for (let p = o.length - 1; p >= 0; p--) {
              const b = o[p];
              if (b.href === u && (!h || b.rel === "stylesheet")) return;
            }
          else if (document.querySelector(`link[href="${u}"]${y}`)) return;
          const f = document.createElement("link");
          if (
            ((f.rel = h ? "stylesheet" : it),
            h || (f.as = "script"),
            (f.crossOrigin = ""),
            (f.href = u),
            d && f.setAttribute("nonce", d),
            document.head.appendChild(f),
            h)
          )
            return new Promise((p, b) => {
              (f.addEventListener("load", p),
                f.addEventListener("error", () => b(new Error(`Unable to preload CSS for ${u}`))));
            });
        })
      );
    }
    function i(o) {
      const s = new Event("vite:preloadError", { cancelable: !0 });
      if (((s.payload = o), window.dispatchEvent(s), !s.defaultPrevented)) throw o;
    }
    return a.then((o) => {
      for (const s of o || []) s.status === "rejected" && i(s.reason);
      return e().catch(i);
    });
  },
  j = "liquid-ajax-cart",
  E = "data-ajax-cart",
  ze = "ajax-cart",
  Q = "js-ajax-cart",
  Re = `${j}:init`;
var Oe = function (t, e, n, r) {
  return new (n || (n = Promise))(function (a, i) {
    function o(l) {
      try {
        d(r.next(l));
      } catch (u) {
        i(u);
      }
    }
    function s(l) {
      try {
        d(r.throw(l));
      } catch (u) {
        i(u);
      }
    }
    function d(l) {
      var u;
      l.done
        ? a(l.value)
        : ((u = l.value),
          u instanceof n
            ? u
            : new n(function (h) {
                h(u);
              })).then(o, s);
    }
    d((r = r.apply(t, [])).next());
  });
};
const R = "add",
  Y = "change",
  ee = "update",
  Le = "clear",
  k = "get",
  at = `${j}:queue-start`,
  B = `${j}:queue-start-internal`,
  Ge = `${j}:queue-empty-internal`,
  M = `${j}:queue-end-internal`,
  st = `${j}:queue-end`,
  G = `${j}:request-start-internal`,
  ut = `${j}:request-start`,
  x = `${j}:request-end-internal`,
  ct = `${j}:request-end`,
  A = [];
let K = !1;
function O(t) {
  var e;
  !((e = t.options) === null || e === void 0) && e.important && A.length !== 0
    ? A[0].push(t)
    : A.push([t]) === 1 && (Ke(!0), ge());
}
function ge() {
  if (A.length === 1 && A[0].length === 0) {
    const r = new CustomEvent(Ge);
    document.dispatchEvent(r);
  }
  if (A.length === 0) return void Ke(!1);
  if (A[0].length === 0) return (A.shift(), void ge());
  const { requestType: t, body: e, options: n } = A[0][0];
  (function (r, a, i, o) {
    var s;
    const { extraRequestOnError: d } = q,
      l = Ye(r);
    let u;
    r !== k && (u = a || {});
    const h = r === k ? "GET" : "POST",
      y = i.info || {},
      f = { requestType: r, endpoint: l, requestBody: u, info: y },
      p = [],
      b = [],
      F = new CustomEvent(G, {
        detail: { requestState: { requestType: r, endpoint: l, info: y, requestBody: u } },
      });
    document.dispatchEvent(F);
    const N = new CustomEvent(ut, {
      detail: { requestState: { requestType: r, endpoint: l, info: y, requestBody: u } },
    });
    if ((document.dispatchEvent(N), y.cancel)) return ((f.responseData = null), void re(i, o, f));
    if (!((s = i?.signal) === null || s === void 0) && s.aborted)
      return ((f.responseData = null), (f.fetchError = "AbortError"), void re(i, o, f));
    if (u !== void 0) {
      let c;
      if (
        (u instanceof FormData || u instanceof URLSearchParams
          ? u.has("sections") && (c = u.get("sections").toString())
          : (c = u.sections),
        typeof c == "string" || c instanceof String || Array.isArray(c))
      ) {
        if (
          (Array.isArray(c) ? p.push(...c) : p.push(...c.split(",")),
          R === r && b.push(...p.slice(0, 5)),
          p.length > 5)
        ) {
          b.push(...p.slice(5));
          const m = p.slice(0, 5).join(",");
          u instanceof FormData || u instanceof URLSearchParams
            ? u.set("sections", m)
            : (u.sections = m);
        }
      } else
        c != null &&
          console.error(
            `Liquid Ajax Cart: "sections" parameter in a Cart Ajax API request must be a string or an array. Now it is ${c}`
          );
    }
    const v = { method: h };
    (i?.signal && (v.signal = i.signal),
      r !== k &&
        (u instanceof FormData || u instanceof URLSearchParams
          ? ((v.body = u), (v.headers = { "x-requested-with": "XMLHttpRequest" }))
          : ((v.body = JSON.stringify(u)), (v.headers = { "Content-Type": "application/json" }))),
      fetch(l, v)
        .then((c) =>
          Oe(this, void 0, void 0, function* () {
            const m = yield c.json();
            return { ok: c.ok, status: c.status, body: m };
          })
        )
        .then((c) =>
          Oe(this, void 0, void 0, function* () {
            var m;
            return (
              (f.responseData = c),
              !f.responseData.ok && d && b.unshift(...p.slice(0, 5)),
              b.length > 0 &&
                ((!((m = i?.signal) === null || m === void 0) && m.aborted) ||
                  (f.extraResponseData = yield Xe(b, i?.signal))),
              f
            );
          })
        )
        .catch((c) => {
          ((!c || (c.name !== "AbortError" && c.code !== 20)) &&
            (console.error("Liquid Ajax Cart: Error while performing cart Ajax request"),
            console.error(c)),
            (f.responseData = null),
            (f.fetchError = c));
        })
        .finally(() => {
          re(i, o, f);
        }));
  })(t, e, n, () => {
    (A[0].shift(), ge());
  });
}
function Ke(t) {
  K = t;
  const e = new CustomEvent(K ? B : M);
  document.dispatchEvent(e);
  const n = new CustomEvent(K ? at : st);
  document.dispatchEvent(n);
}
function re(t, e, n) {
  if ("firstCallback" in t)
    try {
      t.firstCallback(n);
    } catch (o) {
      (console.error('Liquid Ajax Cart: Error in request "firstCallback" function'),
        console.error(o));
    }
  const r = { requestState: n },
    a = new CustomEvent(x, { detail: r });
  document.dispatchEvent(a);
  const i = new CustomEvent(ct, { detail: r });
  if ((document.dispatchEvent(i), "lastCallback" in t))
    try {
      t.lastCallback(n);
    } catch (o) {
      (console.error('Liquid Ajax Cart: Error in request "lastCallback" function'),
        console.error(o));
    }
  e();
}
function Xe(t = [], e) {
  const n = { updates: {} };
  return (
    t.length > 0 && (n.sections = t.slice(0, 5).join(",")),
    fetch(Ye(ee), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(n),
      signal: e,
    }).then((r) =>
      r.json().then((a) => {
        const i = { ok: r.ok, status: r.status, body: a };
        return t.length < 6
          ? i
          : Xe(t.slice(5), e).then((o) => {
              var s;
              return (
                o.ok &&
                  !((s = o.body) === null || s === void 0) &&
                  s.sections &&
                  typeof o.body.sections == "object" &&
                  ("sections" in i.body || (i.body.sections = {}),
                  (i.body.sections = Object.assign(
                    Object.assign({}, i.body.sections),
                    o.body.sections
                  ))),
                i
              );
            });
      })
    )
  );
}
function dt(t = {}) {
  O({ requestType: k, body: void 0, options: t });
}
function je(t = {}, e = {}) {
  O({ requestType: R, body: t, options: e });
}
function te(t = {}, e = {}) {
  O({ requestType: Y, body: t, options: e });
}
function P(t = {}, e = {}) {
  O({ requestType: ee, body: t, options: e });
}
function Qe(t = {}, e = {}) {
  O({ requestType: Le, body: t, options: e });
}
function Ye(t) {
  var e, n, r, a, i, o, s, d, l, u;
  switch (t) {
    case R:
      return `${((n = (e = window.Shopify) === null || e === void 0 ? void 0 : e.routes) === null || n === void 0 ? void 0 : n.root) || "/"}cart/add.js`;
    case Y:
      return `${((a = (r = window.Shopify) === null || r === void 0 ? void 0 : r.routes) === null || a === void 0 ? void 0 : a.root) || "/"}cart/change.js`;
    case k:
      return `${((o = (i = window.Shopify) === null || i === void 0 ? void 0 : i.routes) === null || o === void 0 ? void 0 : o.root) || "/"}cart.js`;
    case Le:
      return `${((d = (s = window.Shopify) === null || s === void 0 ? void 0 : s.routes) === null || d === void 0 ? void 0 : d.root) || "/"}cart/clear.js`;
    case ee:
      return `${((u = (l = window.Shopify) === null || l === void 0 ? void 0 : l.routes) === null || u === void 0 ? void 0 : u.root) || "/"}cart/update.js`;
    default:
      return;
  }
}
function L() {
  return K;
}
const Ne = `${E}-initial-state`;
let we,
  S = null;
function $() {
  return { cart: S, previousCart: we };
}
const ie = `${E}-bind`;
function oe() {
  $().cart &&
    document.querySelectorAll(`[${ie}]`).forEach((t) => {
      const e = t.getAttribute(ie);
      t.textContent = (function (n) {
        const { binderFormatters: r } = q,
          [a, ...i] = n.split("|");
        let o = et(a, $().cart);
        return (
          i.forEach((s) => {
            const d = s.trim();
            d !== "" &&
              (typeof r == "object" && d in r
                ? (o = r[d](o))
                : d in Be
                  ? (o = Be[d](o))
                  : console.warn(`Liquid Ajax Cart: the "${d}" formatter is not found`));
          }),
          typeof o == "string" || o instanceof String || typeof o == "number" || o instanceof Number
            ? o.toString()
            : (console.error(
                `Liquid Ajax Cart: the calculated value for the ${ie}="${n}" element must be string or number. But the value is`,
                o
              ),
              "")
        );
      })(e);
    });
}
function et(t, e) {
  const n = t.split("."),
    r = n.shift().trim();
  return r !== "" && r in e && n.length > 0 ? et(n.join("."), e[r]) : e[r];
}
const Be = {
  money_with_currency: (t) => {
    var e;
    const n = $();
    if (typeof t != "number" && !(t instanceof Number))
      return (
        console.error(
          "Liquid Ajax Cart: the 'money_with_currency' formatter is not applied because the value is not a number. The value is ",
          t
        ),
        t
      );
    const r = t / 100;
    return "Intl" in window && !((e = window.Shopify) === null || e === void 0) && e.locale
      ? Intl.NumberFormat(window.Shopify.locale, {
          style: "currency",
          currency: n.cart.currency,
        }).format(r)
      : `${r.toFixed(2)} ${n.cart.currency}`;
  },
};
let D,
  $e = !1;
function ae() {
  const { mutations: t } = q;
  (Array.isArray(t) ||
    console.error('Liquid Ajax Cart: the "mutations" settings parameter must be an array'),
    t.length !== 0 && (($e = !1), (D = -1), xe()));
}
function xe() {
  const { mutations: t } = q;
  if ((D++, D >= t.length)) return;
  let e = [];
  try {
    const n = t[D]();
    n && (e = n?.requests || []);
  } catch (n) {
    (console.error(`Liquid Ajax Cart: Error in the "mutation" function with index ${D}`),
      console.error(n));
  }
  Array.isArray(e) ? Ee(e) : xe();
}
function Ee(t) {
  const e = t.shift();
  if (e) {
    if (e.type && [R, Y, ee, Le, k].includes(e.type))
      return void O({
        requestType: e.type,
        body: e.body,
        options: {
          info: { initiator: "mutation" },
          important: !0,
          lastCallback: (n) => {
            Ee(t);
          },
        },
      });
    console.error(`Liquid Ajax Cart: wrong request type in the mutation with index ${D}`);
  }
  t.length > 0 ? Ee(t) : xe();
}
const q = {
    binderFormatters: {},
    requestErrorText: "There was an error while updating your cart. Please try again.",
    updateOnWindowFocus: !0,
    quantityTagAllowZero: !1,
    quantityTagDebounce: 300,
    mutations: [],
    extraRequestOnError: !0,
  },
  _ = `${E}-section`,
  se = `${E}-static-element`,
  ue = `${E}-section-scroll`,
  ce = "shopify-section-",
  Ae = `${ze}-product-form`,
  de = "processing";
class tt extends HTMLElement {
  connectedCallback() {
    var e, n;
    const r = this,
      a = this.querySelectorAll("form");
    if (a.length !== 1)
      return void console.error(
        `Liquid Ajax Cart: "${Ae}" element must have one "form" element as a child, ${a.length} found`,
        r
      );
    const i = a[0];
    new URL(i.action).pathname ===
    `${((n = (e = window.Shopify) === null || e === void 0 ? void 0 : e.routes) === null || n === void 0 ? void 0 : n.root) || "/"}cart/add`
      ? i.addEventListener("submit", (o) => {
          if (!r.hasAttribute(de)) {
            const s = new FormData(i);
            (r.setAttribute(de, ""),
              je(s, {
                lastCallback: () => {
                  r.removeAttribute(de);
                },
                info: { initiator: r },
              }));
          }
          o.preventDefault();
        })
      : console.error(
          `Liquid Ajax Cart: "${Ae}" element's form "action" attribute value isn't a product form action URL`,
          i,
          r
        );
  }
}
var le, fe, pe, he, me, ye, ve, be;
const I = `${((fe = (le = window.Shopify) === null || le === void 0 ? void 0 : le.routes) === null || fe === void 0 ? void 0 : fe.root) || "/"}cart/change`,
  H = `${((he = (pe = window.Shopify) === null || pe === void 0 ? void 0 : pe.routes) === null || he === void 0 ? void 0 : he.root) || "/"}cart/add`,
  U = `${((ye = (me = window.Shopify) === null || me === void 0 ? void 0 : me.routes) === null || ye === void 0 ? void 0 : ye.root) || "/"}cart/clear`,
  V = `${((be = (ve = window.Shopify) === null || ve === void 0 ? void 0 : ve.routes) === null || be === void 0 ? void 0 : be.root) || "/"}cart/update`,
  T = `${E}-request-button`;
function lt(t, e) {
  let n;
  const r = [I, H, U, V];
  if (!t.hasAttribute(T)) return;
  const a = t.getAttribute(T);
  if (a) {
    let o;
    try {
      if (((o = new URL(a, window.location.origin)), !r.includes(o.pathname)))
        throw `URL should be one of the following: ${I}, ${H}, ${V}, ${U}`;
      n = o;
    } catch (s) {
      console.error(`Liquid Ajax Cart: ${T} contains an invalid URL as a parameter.`, s);
    }
  } else if (t instanceof HTMLAnchorElement && t.hasAttribute("href")) {
    const o = new URL(t.href);
    r.includes(o.pathname)
      ? (n = o)
      : t.hasAttribute(T) &&
        console.error(
          `Liquid Ajax Cart: a link with the ${T} contains an invalid href URL.`,
          `URL should be one of the following: ${I}, ${H}, ${V}, ${U}`
        );
  }
  if (n === void 0)
    return void console.error(`Liquid Ajax Cart: a ${T} element doesn't have a valid URL`);
  if ((e && e.preventDefault(), L())) return;
  const i = new FormData();
  switch (
    (n.searchParams.forEach((o, s) => {
      i.append(s, o);
    }),
    n.pathname)
  ) {
    case H:
      je(i, { info: { initiator: t } });
      break;
    case I:
      te(i, { info: { initiator: t } });
      break;
    case V:
      P(i, { info: { initiator: t } });
      break;
    case U:
      Qe({}, { info: { initiator: t } });
  }
}
function ne(t, e) {
  let n, r;
  return (
    t.length > 3
      ? ((n = e.cart.items.find((a) => a.key === t)), (r = "id"))
      : ((n = e.cart.items[Number(t) - 1]), (r = "line")),
    n === void 0 &&
      ((n = null), console.error(`Liquid Ajax Cart: line item with ${r}="${t}" not found`)),
    [n, r]
  );
}
const g = `${E}-quantity-input`;
function Se(t) {
  return !(
    !t.hasAttribute(g) ||
    (!(
      (t instanceof HTMLInputElement && ["text", "number"].includes(t.type)) ||
      (t instanceof HTMLSelectElement && ["select-one"].includes(t.type))
    ) &&
      (console.error(
        `Liquid Ajax Cart: the ${g} attribute supports "input" elements of types "text", "number" and non-multiple "select" elements`
      ),
      1))
  );
}
function J() {
  document.querySelectorAll(`input[${g}], select[${g}]`).forEach((t) => {
    if (!Se(t)) return;
    if (L()) return void (t.disabled = !0);
    const e = $(),
      n = t.getAttribute(g).trim(),
      [r] = ne(n, e);
    (r ? (t.value = r.quantity.toString()) : r === null && (t.value = "0"), (t.disabled = !1));
  });
}
function Me(t, e) {
  if (!Se(t) || (e && e.preventDefault(), L())) return;
  let n = Number(t.value.trim());
  const r = t.getAttribute(g).trim();
  if (isNaN(n))
    return void console.error(`Liquid Ajax Cart: input value of a ${g} must be an Integer number`);
  if ((n < 1 && (n = 0), !r))
    return void console.error(
      `Liquid Ajax Cart: attribute value of a ${g} must be an item key or an item index`
    );
  const a = r.length > 3 ? "id" : "line",
    i = new FormData();
  (i.set(a, r), i.set("quantity", n.toString()), te(i, { info: { initiator: t } }), t.blur());
}
const w = `${E}-property-input`;
function Pe(t) {
  const e = t.getAttribute(w),
    n = t.getAttribute("name");
  console.error(
    `Liquid Ajax Cart: the element [${w}="${e}"]${n ? `[name="${n}"]` : ""} has wrong attributes.`
  );
}
function Ce(t) {
  return (
    !!t.hasAttribute(w) &&
    ((t instanceof HTMLInputElement && t.type !== "hidden") ||
      t instanceof HTMLTextAreaElement ||
      t instanceof HTMLSelectElement)
  );
}
function _e(t) {
  const e = { objectCode: void 0, propertyName: void 0, attributeValue: void 0 };
  if (!t.hasAttribute(w)) return e;
  let n = t.getAttribute(w).trim();
  if (!n) {
    const i = t.getAttribute("name").trim();
    i && (n = i);
  }
  if (!n) return (Pe(t), e);
  if (((e.attributeValue = n), n === "note")) return ((e.objectCode = "note"), e);
  let [r, ...a] = n.trim().split("[");
  return !a || a.length !== 1 || a[0].length < 2 || a[0].indexOf("]") !== a[0].length - 1
    ? (Pe(t), e)
    : ((e.objectCode = r), (e.propertyName = a[0].replace("]", "")), e);
}
function W() {
  document.querySelectorAll(`[${w}]`).forEach((t) => {
    if (!Ce(t)) return;
    if (L()) return void (t.disabled = !0);
    const { objectCode: e, propertyName: n, attributeValue: r } = _e(t);
    if (!e) return;
    const a = $();
    let i,
      o = !1;
    if (e === "note") i = a.cart.note;
    else if (e === "attributes") i = a.cart.attributes[n];
    else {
      const [s, d] = ne(e, a);
      (s && (i = s.properties[n]),
        s === null &&
          (console.error(
            `Liquid Ajax Cart: line item with ${d}="${e}" was not found when the [${w}] element with "${r}" value tried to get updated from the State`
          ),
          (o = !0)));
    }
    (t instanceof HTMLInputElement && (t.type === "checkbox" || t.type === "radio")
      ? (t.checked = t.value === i)
      : (typeof i == "string" ||
          i instanceof String ||
          typeof i == "number" ||
          i instanceof Number ||
          (Array.isArray(i) || i instanceof Object
            ? ((i = JSON.stringify(i)),
              console.warn(
                `Liquid Ajax Cart: the ${w} with the "${r}" value is bound to the ${n} ${e === "attributes" ? "attribute" : "property"} that is not string or number: ${i}`
              ))
            : (i = "")),
        (t.value = i)),
      o || (t.disabled = !1));
  });
}
function Fe(t, e) {
  if (!Ce(t)) return;
  (e && e.preventDefault(), t.blur());
  const n = $();
  if (L()) return;
  const { objectCode: r, propertyName: a, attributeValue: i } = _e(t);
  if (!r) return;
  let o = t.value;
  if (t instanceof HTMLInputElement && t.type === "checkbox" && !t.checked) {
    let s = document.querySelector(`input[type="hidden"][${w}="${i}"]`);
    (s ||
      (r !== "note" && r !== "attributes") ||
      (s = document.querySelector(`input[type="hidden"][${w}][name="${i}"]`)),
      (o = s ? s.value : ""));
  }
  if (r === "note") {
    const s = new FormData();
    (s.set("note", o), P(s, { info: { initiator: t } }));
  } else if (r === "attributes") {
    const s = new FormData();
    (s.set(`attributes[${a}]`, o), P(s, { info: { initiator: t } }));
  } else {
    const [s, d] = ne(r, n);
    if (
      (s === null &&
        console.error(
          `Liquid Ajax Cart: line item with ${d}="${r}" was not found when the [${w}] element with "${i}" value tried to update the cart`
        ),
      !s)
    )
      return;
    const l = Object.assign({}, s.properties);
    l[a] = o;
    const u = new FormData();
    let h = u;
    (u.set(d, r), u.set("quantity", s.quantity.toString()));
    for (let y in l) {
      const f = l[y];
      typeof f == "string" || f instanceof String
        ? u.set(`properties[${y}]`, l[y])
        : (h = { [d]: r, quantity: s.quantity, properties: l });
    }
    te(h, { info: { initiator: t } });
  }
}
const Z = `${ze}-quantity`,
  Ie = `${E}-quantity-plus`,
  He = `${E}-quantity-minus`;
function ft() {
  (customElements.define(Ae, tt),
    document.addEventListener(
      "click",
      function (t) {
        for (let e = t.target; e && e != document.documentElement; e = e.parentElement) lt(e, t);
      },
      !1
    ),
    document.addEventListener(
      "change",
      function (t) {
        Fe(t.target, t);
      },
      !1
    ),
    document.addEventListener(
      "keydown",
      function (t) {
        const e = t.target;
        (t.key === "Enter" && ((e instanceof HTMLTextAreaElement && !t.ctrlKey) || Fe(e, t)),
          t.key === "Escape" &&
            (function (n) {
              if (
                !Ce(n) ||
                !(n instanceof HTMLInputElement || n instanceof HTMLTextAreaElement) ||
                (n instanceof HTMLInputElement && (n.type === "checkbox" || n.type === "radio"))
              )
                return;
              const r = $(),
                { objectCode: a, propertyName: i } = _e(n);
              if (!a) return;
              let o;
              if (a === "note") o = r.cart.note;
              else if (a === "attributes") o = r.cart.attributes[i];
              else {
                const [s] = ne(a, r);
                s && (o = s.properties[i]);
              }
              (o !== void 0 &&
                (o || typeof o == "string" || o instanceof String || (o = ""),
                (n.value = String(o))),
                n.blur());
            })(e));
      },
      !1
    ),
    document.addEventListener(B, W),
    document.addEventListener(x, W),
    document.addEventListener(M, W),
    W(),
    document.addEventListener(
      "change",
      function (t) {
        Me(t.target, t);
      },
      !1
    ),
    document.addEventListener(
      "keydown",
      function (t) {
        (t.key === "Enter" && Me(t.target, t),
          t.key === "Escape" &&
            (function (e) {
              if (!Se(e)) return;
              const n = e.getAttribute(g).trim();
              let r;
              const a = $();
              if (n.length > 3) r = a.cart.items.find((i) => i.key === n);
              else {
                const i = Number(n) - 1;
                r = a.cart.items[i];
              }
              (r && (e.value = r.quantity.toString()), e.blur());
            })(t.target));
      },
      !1
    ),
    document.addEventListener(B, J),
    document.addEventListener(x, J),
    document.addEventListener(M, J),
    J(),
    customElements.define(
      Z,
      class extends HTMLElement {
        constructor() {
          (super(...arguments), (this._timer = void 0));
        }
        connectedCallback() {
          const t = this.querySelectorAll("input");
          t.length === 1
            ? ((this._$input = t[0]),
              this._$input.hasAttribute(g)
                ? ((this._$buttons = Array.from(this.querySelectorAll(`[${He}], [${Ie}]`))),
                  this._$input.addEventListener("change", this._updateDOM.bind(this)),
                  document.addEventListener(B, this._updateDOM.bind(this)),
                  document.addEventListener(x, this._updateDOM.bind(this)),
                  document.addEventListener(M, this._updateDOM.bind(this)),
                  this._updateDOM(),
                  this._$buttons.forEach((e) => {
                    (e.addEventListener("click", (n) => {
                      const { quantityTagAllowZero: r } = q,
                        a = r === !0 ? 0 : 1;
                      if (!L()) {
                        const i = Number(this._$input.value);
                        if (isNaN(i))
                          return void console.error(
                            `Liquid Ajax Cart: "${Z}" element's input value isn't a number`,
                            this._$input,
                            this
                          );
                        let o = i,
                          s = Number(this._$input.getAttribute("step") || 1);
                        ((!Number.isSafeInteger(s) || s <= 0) && (s = 1),
                          (o = e.hasAttribute(Ie) ? o + s : o - s),
                          o < a && (o = a),
                          o !== i &&
                            ((this._$input.value = o.toString()),
                            this._runAwaiting(),
                            this._updateDOM()));
                      }
                      n.preventDefault();
                    }),
                      e.addEventListener("focusout", (n) => {
                        (n.relatedTarget && e.contains(n.relatedTarget)) ||
                          (this._timer !== void 0 && this._runRequest());
                      }));
                  }))
                : console.error(
                    `Liquid Ajax Cart: "${Z}" element's input must have the "${g}" attribute`,
                    this._$input,
                    this
                  ))
            : console.error(
                `Liquid Ajax Cart: "${Z}" element must have one "input" element as a child, ${t.length} found`,
                this
              );
        }
        _runAwaiting() {
          const { quantityTagDebounce: t } = q;
          (this._timer !== void 0 && clearTimeout(this._timer),
            t > 0
              ? (this._timer = setTimeout(() => {
                  this._runRequest();
                }, Number(t)))
              : this._runRequest());
        }
        _runRequest() {
          (this._timer !== void 0 && clearTimeout(this._timer),
            (this._timer = void 0),
            L() || this._$input.dispatchEvent(new Event("change", { bubbles: !0 })));
        }
        _updateDOM() {
          this._$buttons.forEach((t) => {
            const e =
              L() || (t.hasAttribute(He) && !q.quantityTagAllowZero && this._$input.value === "1");
            (e ? t.setAttribute("aria-disabled", "true") : t.removeAttribute("aria-disabled"),
              t instanceof HTMLButtonElement && t.toggleAttribute("disabled", e));
          });
        }
      }
    ));
}
const qe = `${E}-errors`,
  Ue = (t) => {
    switch (t.requestType) {
      case R:
        return ((e) => {
          var n;
          const r = (n = e.info) === null || n === void 0 ? void 0 : n.initiator;
          return r instanceof tt ? Array.from(r.querySelectorAll(`[${qe}="form"]`)) : [];
        })(t);
      case Y:
        return ((e) => {
          var n;
          const r = [],
            a = $();
          let i, o;
          if (
            (e.requestBody instanceof FormData || e.requestBody instanceof URLSearchParams
              ? (e.requestBody.has("line") && (o = e.requestBody.get("line").toString()),
                e.requestBody.has("id") && (i = e.requestBody.get("id").toString()))
              : ("line" in e.requestBody && (o = String(e.requestBody.line)),
                "id" in e.requestBody && (i = String(e.requestBody.id))),
            o)
          ) {
            const s = Number(o);
            if (s > 0) {
              const d = s - 1;
              i = (n = a.cart.items[d]) === null || n === void 0 ? void 0 : n.key;
            }
          }
          return (
            i &&
              (i.indexOf(":") > -1
                ? r.push(...Array.from(document.querySelectorAll(`[${qe}="${i}"]`)))
                : r.push(
                    ...Array.from(
                      document.querySelectorAll(
                        a.cart.items
                          .reduce(
                            (s, d) => (
                              (d.key !== i && d.id !== Number(i)) || s.push(`[${qe}="${d.key}"]`),
                              s
                            ),
                            []
                          )
                          .join(",")
                      )
                    )
                  )),
            r
          );
        })(t);
      default:
        return [];
    }
  },
  pt = `${Q}-init`,
  ht = `${Q}-processing`,
  mt = `${Q}-empty`,
  yt = `${Q}-not-empty`;
function z() {
  const t = document.querySelector("html"),
    e = $();
  (t.classList.toggle(pt, e.cart !== null),
    t.classList.toggle(ht, L()),
    t.classList.toggle(mt, e.cart.item_count === 0),
    t.classList.toggle(yt, e.cart.item_count > 0));
}
let Ve = !1;
if (!("liquidAjaxCart" in window)) {
  let t = function (e, n) {
    Object.defineProperty(window.liquidAjaxCart, e, {
      get: n,
      set: () => {
        throw new Error(`Liquid Ajax Cart: the "${e}" is a read-only property`);
      },
      enumerable: !0,
    });
  };
  ((window.liquidAjaxCart = {
    conf: function (e, n) {
      e in q
        ? ((q[e] = n),
          window.liquidAjaxCart.init &&
            (e === "binderFormatters" && oe(), e === "mutations" && ae()))
        : console.error(`Liquid Ajax Cart: unknown configuration parameter "${e}"`);
    },
  }),
    t("init", () => Ve),
    document.addEventListener(G, (e) => {
      const { requestState: n } = e.detail;
      if (n.requestBody !== void 0) {
        const r = [];
        if (
          (document.querySelectorAll(`[${_}]`).forEach((a) => {
            const i = a.closest(`[id^="${ce}"]`);
            if (i) {
              const o = i.id.replace(ce, "");
              r.indexOf(o) === -1 && r.push(o);
            } else
              console.error(
                `Liquid Ajax Cart: there is a ${_} element that is not inside a Shopify section. All the ${_} elements must be inside Shopify sections.`
              );
          }),
          r.length)
        ) {
          let a,
            i = r.join(",");
          (n.requestBody instanceof FormData || n.requestBody instanceof URLSearchParams
            ? n.requestBody.has("sections") && (a = n.requestBody.get("sections").toString())
            : (a = n.requestBody.sections),
            (((typeof a == "string" || a instanceof String) && a !== "") ||
              (a && Array.isArray(a) && a.length > 0)) &&
              (i = `${a.toString()},${i}`),
            n.requestBody instanceof FormData || n.requestBody instanceof URLSearchParams
              ? n.requestBody.set("sections", i)
              : (n.requestBody.sections = i));
        }
      }
    }),
    document.addEventListener(x, (e) => {
      var n, r, a, i;
      e.detail.sections = [];
      const { requestState: o } = e.detail,
        s = new DOMParser(),
        d = [];
      if (
        o.responseData.body.sections ||
        (!(
          (r = (n = o.extraResponseData) === null || n === void 0 ? void 0 : n.body) === null ||
          r === void 0
        ) &&
          r.sections)
      ) {
        let l = o.responseData.body.sections;
        !(
          (i = (a = o.extraResponseData) === null || a === void 0 ? void 0 : a.body) === null ||
          i === void 0
        ) &&
          i.sections &&
          (l = Object.assign(Object.assign({}, l), o.extraResponseData.body.sections));
        for (let u in l)
          l[u]
            ? document.querySelectorAll(`#shopify-section-${u}`).forEach((h) => {
                let y = [];
                const f = "__noId__",
                  p = {};
                h.querySelectorAll(` [${ue}] `).forEach((v) => {
                  let c = v.getAttribute(ue).toString().trim();
                  (c === "" && (c = f),
                    c in p || (p[c] = []),
                    p[c].push({ scroll: v.scrollTop, height: v.scrollHeight }));
                });
                const b = {},
                  F = h.querySelectorAll(`[${se}]`);
                F &&
                  F.forEach((v) => {
                    let c = v.getAttribute(se).toString().trim();
                    (c === "" && (c = f), c in b || (b[c] = []), b[c].push(v));
                  });
                const N = h.querySelectorAll(`[${_}]`);
                if (N) {
                  const v = s.parseFromString(l[u], "text/html");
                  v.querySelectorAll('img[loading="lazy"]').forEach((m) => {
                    m.removeAttribute("loading");
                  });
                  for (let m in b)
                    v.querySelectorAll(` [${se}="${m.replace(f, "")}"] `).forEach((C, Te) => {
                      Te + 1 <= b[m].length && (C.before(b[m][Te]), C.parentElement.removeChild(C));
                    });
                  const c = v.querySelectorAll(`[${_}]`);
                  if (N.length !== c.length) {
                    console.error(
                      `Liquid Ajax Cart: the received HTML for the "${u}" section has a different quantity of the "${_}" containers. The section will be updated completely.`
                    );
                    const m = v.querySelector(`#${ce}${u}`);
                    if (m) {
                      for (h.innerHTML = ""; m.childNodes.length; ) h.appendChild(m.firstChild);
                      y.push(h);
                    }
                  } else
                    N.forEach((m, C) => {
                      (m.before(c[C]), m.parentElement.removeChild(m), y.push(c[C]));
                    });
                }
                for (let v in p)
                  h.querySelectorAll(` [${ue}="${v.replace(f, "")}"] `).forEach((c, m) => {
                    m + 1 <= p[v].length &&
                      (o.requestType !== R || p[v][m].height >= c.scrollHeight) &&
                      (c.scrollTop = p[v][m].scroll);
                  });
                y.length > 0 && d.push({ id: u, elements: y });
              })
            : console.error(
                `Liquid Ajax Cart: the HTML for the "${u}" section was requested but the response is ${l[u]}`
              );
      }
      d.length > 0 && (e.detail.sections = d);
    }),
    document.addEventListener(G, (e) => {
      const { requestState: n } = e.detail;
      Ue(n).forEach((r) => {
        r.textContent = "";
      });
    }),
    document.addEventListener(x, (e) => {
      const { requestState: n } = e.detail;
      if (n.info.cancel) return;
      const r = Ue(n);
      if (r.length === 0) return;
      const a = (function (i) {
        var o, s, d, l, u, h, y;
        const { requestErrorText: f } = q;
        if (!((o = i.responseData) === null || o === void 0) && o.ok) return "";
        const p =
          ((d = (s = i.responseData) === null || s === void 0 ? void 0 : s.body) === null ||
          d === void 0
            ? void 0
            : d.errors) ||
          ((u = (l = i.responseData) === null || l === void 0 ? void 0 : l.body) === null ||
          u === void 0
            ? void 0
            : u.description) ||
          ((y = (h = i.responseData) === null || h === void 0 ? void 0 : h.body) === null ||
          y === void 0
            ? void 0
            : y.message);
        return p
          ? typeof p == "string"
            ? p
            : typeof p == "object"
              ? Object.values(p)
                  .map((b) => b.join(", "))
                  .join("; ")
              : f
          : f;
      })(n);
      a &&
        r.forEach((i) => {
          i.textContent = a;
        });
    }),
    document.addEventListener(Re, ae),
    document.addEventListener(Ge, () => {
      $e && ae();
    }),
    document.addEventListener(G, (e) => {
      const { requestState: n } = e.detail;
      n.info.initiator !== "mutation" && ($e = !0);
    }),
    (function () {
      document.addEventListener(x, (n) => {
        var r, a;
        const { requestState: i } = n.detail;
        let o;
        (!((r = i.extraResponseData) === null || r === void 0) &&
        r.ok &&
        i.extraResponseData.body.token
          ? (o = i.extraResponseData.body)
          : !((a = i.responseData) === null || a === void 0) &&
            a.ok &&
            i.responseData.body.token &&
            (o = i.responseData.body),
          o && ((we = S), (S = o), (n.detail.previousCart = we), (n.detail.cart = S)));
      });
      const e = document.querySelector(`[${Ne}]`);
      if (e)
        try {
          S = JSON.parse(e.textContent);
        } catch (n) {
          (console.error(`Liquid Ajax Cart: can't parse cart JSON from the "${Ne}" script`),
            console.error(n));
        }
      return new Promise((n, r) => {
        var a, i;
        S
          ? n()
          : fetch(
              `${((i = (a = window.Shopify) === null || a === void 0 ? void 0 : a.routes) === null || i === void 0 ? void 0 : i.root) || "/"}cart.js`,
              { headers: { "Content-Type": "application/json" } }
            )
              .then((o) => o.json())
              .then((o) => {
                ((S = o), n());
              })
              .catch((o) => {
                (console.error(o), r(`Can't load the cart state from the "/cart.js" endpoint`));
              });
      });
    })().then(() => {
      (document.addEventListener(x, oe),
        oe(),
        ft(),
        document.addEventListener(B, z),
        document.addEventListener(x, z),
        document.addEventListener(M, z),
        z(),
        (window.liquidAjaxCart.get = dt),
        (window.liquidAjaxCart.add = je),
        (window.liquidAjaxCart.change = te),
        (window.liquidAjaxCart.update = P),
        (window.liquidAjaxCart.clear = Qe),
        t("cart", () => $().cart),
        t("processing", L),
        window.addEventListener("focus", () => {
          q.updateOnWindowFocus && P({}, {});
        }),
        window.addEventListener("pageshow", (n) => {
          (n.persisted || performance.getEntriesByType("navigation")[0].type === "back_forward") &&
            window.liquidAjaxCart.update({}, {});
        }),
        (Ve = !0));
      const e = new CustomEvent(Re);
      document.dispatchEvent(e);
    }));
}
let Je = !1;
function vt() {
  Je ||
    ((Je = !0),
    document.addEventListener("liquid-ajax-cart:init", () => {
      const t = window.liquidAjaxCart?.cart ?? null;
      document.dispatchEvent(
        new De(t, "liquid-ajax-cart:init", {
          source: "liquid-ajax-cart",
          itemCount: t?.item_count ?? 0,
        })
      );
    }),
    document.addEventListener("liquid-ajax-cart:request-end", (t) => {
      const { requestState: e } = t.detail,
        n = window.liquidAjaxCart?.cart ?? null;
      if (!e.responseData?.ok || e.fetchError) {
        const i = e.responseData?.body ?? {};
        document.dispatchEvent(
          new nt(
            "liquid-ajax-cart",
            i.message ?? e.fetchError ?? "Cart request failed",
            i.description ?? null,
            i.errors ?? null
          )
        );
        return;
      }
      const a = {
        source: "liquid-ajax-cart",
        requestType: e.requestType,
        itemCount: n?.item_count ?? 0,
        sections: e.requestBody?.sections ?? null,
      };
      e.requestType === "add"
        ? document.dispatchEvent(new rt(n, "liquid-ajax-cart", a))
        : document.dispatchEvent(new De(n, "liquid-ajax-cart", a));
    }));
}
function bt() {
  const t = document.querySelector("#product-retargeting-data");
  if (!t || !t.textContent) return null;
  try {
    const e = JSON.parse(t.textContent);
    return !e?.id || !e?.variant_id || !e?.title
      ? (console.warn("[shopify-events-bridge] Missing required product data fields"), null)
      : {
          productId: e.id,
          variantId: e.variant_id,
          title: e.title,
          price: typeof e.price == "number" ? e.price : parseFloat(e.price) || 0,
          vendor: e.vendor || "",
          type: e.type || "",
          currency: e.currency || window.Shopify?.currency?.active || "EUR",
        };
  } catch (e) {
    return (console.error("[shopify-events-bridge] Failed to parse product data:", e), null);
  }
}
function qt() {
  if (!window.Shopify?.analytics?.publish) return;
  function t() {
    return window.liquidAjaxCart?.subscribeToCartAjaxRequests
      ? (window.liquidAjaxCart.subscribeToCartAjaxRequests((e) => {
          if (e.requestType !== "add" || e.requestState !== "end" || !e.responseData?.ok) return;
          (e.responseData.body?.items || []).forEach((r) => {
            window.Shopify.analytics.publish("product_added_to_cart", {
              cartLine: {
                quantity: r.quantity,
                merchandise: {
                  id: `gid://shopify/ProductVariant/${r.variant_id}`,
                  title: r.variant_title || r.title,
                  product: {
                    id: `gid://shopify/Product/${r.product_id}`,
                    title: r.product_title || r.title,
                    vendor: r.vendor,
                    type: r.product_type,
                    untranslatedTitle: r.product_title || r.title,
                    url: window.location.origin + r.url,
                  },
                  image: r.image ? { src: r.image } : void 0,
                  price: {
                    amount: r.price / 100,
                    currencyCode: window.Shopify?.currency?.active || "EUR",
                  },
                  sku: r.sku,
                  untranslatedTitle: r.variant_title || r.title,
                },
              },
            });
          });
        }),
        !0)
      : !1;
  }
  (t() ||
    document.addEventListener("liquid-ajax-cart:init", () => {
      t();
    }),
    document.addEventListener("page:switched", () => {
      requestAnimationFrame(() => {
        try {
          const e = bt();
          if (!e || !e.productId || !e.variantId) return;
          if (!e.title || !e.price || !e.currency) {
            console.warn("[shopify-events-bridge] Incomplete product data:", e);
            return;
          }
          window.Shopify.analytics.publish("product_viewed", {
            productVariant: {
              id: `gid://shopify/ProductVariant/${e.variantId}`,
              title: e.title,
              price: { amount: e.price, currencyCode: e.currency },
              product: {
                id: `gid://shopify/Product/${e.productId}`,
                title: e.title,
                vendor: e.vendor || "",
                type: e.type || "",
                untranslatedTitle: e.title,
                url: window.location.href,
              },
            },
          });
        } catch (e) {
          console.error("[shopify-events-bridge] Error tracking product view:", e);
        }
      });
    }),
    document.addEventListener("page:switched", (e) => {
      const n = e.detail.url || window.location.pathname;
      if (n.includes("/collections/") && !n.includes("/products/")) {
        const r = n.match(/\/collections\/([^/?]+)/);
        if (r) {
          const a = r[1];
          window.Shopify.analytics.publish("collection_viewed", {
            collection: { id: a, title: a.replace(/-/g, " "), productVariants: [] },
          });
        }
      }
    }));
}
document.querySelector("[data-dialog], [data-modal]") &&
  X(
    () => import("./dialog-Ct72qeOD.js").then((t) => t.d),
    __vite__mapDeps([0, 1, 2, 3]),
    import.meta.url
  );
document.querySelector("[data-predictive-search], predictive-search-component") &&
  X(
    () => import("./predictive-search-Dq3dzU3G.js").then((t) => t.p),
    __vite__mapDeps([4, 1, 5, 6, 2]),
    import.meta.url
  );
const gt = new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
function We() {
  return window.liquidAjaxCart && typeof window.liquidAjaxCart.conf == "function"
    ? (window.liquidAjaxCart.conf("binderFormatters", {
        money: (t) => {
          const e = parseFloat(t) / 100;
          return `${gt.format(e)} €`;
        },
      }),
      !0)
    : !1;
}
We() ||
  document.addEventListener("liquid-ajax-cart:init", () => {
    We();
  });
document.addEventListener("liquid-ajax-cart:request-start", (t) => {
  const { requestState: e } = t.detail;
  e.requestType === "add" && e.requestBody && delete e.requestBody.sections;
});
vt();
qt();
document.readyState === "complete" ? Ze() : window.addEventListener("load", Ze);
function Ze() {
  setTimeout(() => {
    (X(() => import("./product-router-analytics-zxrdmJfV.js"), [], import.meta.url),
      X(() => import("./cart-analytics-CrQXTU1v.js"), [], import.meta.url));
  }, 1500);
}
